import React from 'react'
import "./BookingAppointment.css";
import Mobile from "../../component/mobile/mobile";
import service1 from '../../assets/servicepr3.png';
import service2 from '../../assets/servicepr2.png';
import doctor from '../../assets/doctor3.png';
export default function BookingAppointment() {
    return (
        <>
            <div className="booking-card">
                <div className="booking-left">
                    <div className="logo-box">
                        <div className="logo">
                            <img src={service1} alt="Nursing Video" className="appo-image" />
                        </div>
                    </div>
                </div>
                <div className="booking-right">
                    <div className="doctor-info">
                        <img src={doctor} alt="Doctor" className="doctor-avatar" />
                        <div>
                            <p className="doctor-name">Dr. Frances Sutton</p>
                            <p className="specialist">Nursing Specialists • 12 Years Exp.</p>
                        </div>
                    </div>
                    <div className="details">
                        <div className='row'>
                            <div className='col-md-3 col-5'>
                                <p><strong>Booking Date:</strong></p>
                            </div>
                            <div className='col-md-9 col-7'>
                                <p>12/08/2023</p>
                            </div>
                            <div className='col-md-3 col-5'>
                                <p><strong>Vendor Name:</strong></p>
                            </div>
                            <div className='col-md-9 col-7'>
                                <p>Medical Heath Care Service</p>
                            </div>
                            <div className='col-md-3 col-5'>
                                <p><strong>Booking Id:</strong></p>
                            </div>
                            <div className='col-md-9 col-7'>
                                <p>589623014059748</p>
                            </div>
                            <div className='col-md-3 col-5'>
                                <p><strong>Disease:</strong></p>
                            </div>
                            <div className='col-md-9 col-7'>
                                <p>Tuberculosis (TB)</p>
                            </div>
                            <div className='col-md-3 col-5'>
                                <p><strong>Price:</strong></p>
                            </div>
                            <div className='col-md-9 col-7'>
                                <p>₹ 800</p>
                            </div>
                            <div className='col-md-3 col-5'>
                                <p><strong>Address:</strong></p>
                            </div>
                            <div className='col-md-9 col-7'>
                                <p>525/E, Vyapari Peth, E Ward, Shahupuri, Kolhapur, Maharashtra - 695320</p>
                            </div>
                        </div>
                        <div className="row status-row">
                            <div className='col-md-3 col-5'>
                                <p><strong>Status:</strong></p>
                            </div>
                            <div className='col-md-9 col-7'>
                                <p className="pending">Pending</p>
                            </div>
                        </div>
                    </div>
                    <button className="cancel-btn">Cancel</button>
                </div>
            </div>

            <div className="booking-card">
                <div className="booking-left">
                    <div className="logo-box">
                        <div className="logo">
                            <img src={service2} alt="Nursing Video" className="appo-image" />
                        </div>
                    </div>
                </div>
                <div className="booking-right">
                    <div className="doctor-info">
                        <img src={doctor} alt="Doctor" className="doctor-avatar" />
                        <div>
                            <p className="doctor-name">Dr. Frances Sutton</p>
                            <p className="specialist">Nursing Specialists • 12 Years Exp.</p>
                        </div>
                    </div>
                    <div className="details">
                        <div className='row'>
                            <div className='col-md-3 col-5'>
                                <p><strong>Booking Date:</strong></p>
                            </div>
                            <div className='col-md-9 col-7'>
                                <p>12/08/2023</p>
                            </div>
                            <div className='col-md-3 col-5'>
                                <p><strong>Vendor Name:</strong></p>
                            </div>
                            <div className='col-md-9 col-7'>
                                <p>Medical Heath Care Service</p>
                            </div>
                            <div className='col-md-3 col-5'>
                                <p><strong>Booking Id:</strong></p>
                            </div>
                            <div className='col-md-9 col-7'>
                                <p>589623014059748</p>
                            </div>
                            <div className='col-md-3 col-5'>
                                <p><strong>Disease:</strong></p>
                            </div>
                            <div className='col-md-9 col-7'>
                                <p>Tuberculosis (TB)</p>
                            </div>
                            <div className='col-md-3 col-5'>
                                <p><strong>Price:</strong></p>
                            </div>
                            <div className='col-md-9 col-7'>
                                <p>₹ 800</p>
                            </div>
                            <div className='col-md-3 col-5'>
                                <p><strong>Address:</strong></p>
                            </div>
                            <div className='col-md-9 col-7'>
                                <p>525/E, Vyapari Peth, E Ward, Shahupuri, Kolhapur, Maharashtra - 695320</p>
                            </div>
                        </div>
                        <div className="row status-row">
                            <div className='col-md-3 col-5'>
                                <p><strong>Status:</strong></p>
                            </div>
                            <div className='col-md-9 col-7'>
                                <p className="pending">Pending</p>
                            </div>
                        </div>
                    </div>
                    <button className="cancel-btn">Cancel</button>
                </div>
            </div>
            <Mobile />
        </>
    )
}
